import React from 'react'
import BouncingLoader from '../../../Loader/BouncingLoader'
import { NUMBER_FORMAT } from '../constants'

const MetricTotalBox = ({ isLoading, value, currency, label }) => {
  const formattedValue = new Intl.NumberFormat(NUMBER_FORMAT, {
    style: currency && 'currency',
    currency: currency,
  }).format(value)

  return (
    <div className="bg-op-con-dark white pa4 flex flex-column justify-center w-49 ml-auto">
      <div className="mb3 f4"> {label} </div>
      {isLoading ? (
        <BouncingLoader />
      ) : (
        <div className="f1 fw7">{formattedValue}</div>
      )}
    </div>
  )
}

export default MetricTotalBox



// WEBPACK FOOTER //
// ./src/components/Pages/Report/MetricTotalBox/index.js